export const Types = {
    button: 'button',
    checkbox: 'checkbox',
    file: 'file',
    input: 'input',
    number: 'number',
    text: 'text',
    textarea: 'textarea',
    tel: 'tel',
    email: 'email',
    password: 'password',
    select: 'select',
    submit: 'submit',
    suggest: 'suggest',
    radio: 'radio',
};
//# sourceMappingURL=inputs.js.map